import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { UiTranslateModule } from '@fcom/ui-translate';

import { IconsModule } from '../icons/icons.module';
import { AbstractNgModelComponent } from './abstracts/abstract-ng-model.component';
import { AbstractCheckboxComponent } from './abstracts/abstract-checkbox.component';
import { AbstractInputComponent } from './abstracts/abstract-input.component';
import { FloatingInputComponent } from './floating-input/floating-input.component';
import { CheckboxComponent, FcomCheckboxRequiredValidator } from './checkbox/checkbox.component';
import { BlockSelectionGroupComponent } from './block-selection-group/block-selection-group.component';
import { BlockSelectionComponent, BlockSelectionRequiredValidator } from './block-selection/block-selection.component';
import { TooltipModule } from '../tooltip/tooltip.module';
import { RadioItemComponent } from './radio-item/radio-item.component';
import { TextInputComponent } from './text-input/text-input.component';
import { SelectInputComponent } from './select-input/select-input.component';

@NgModule({
  declarations: [
    AbstractCheckboxComponent,
    AbstractInputComponent,
    AbstractNgModelComponent,
    FloatingInputComponent,
    BlockSelectionGroupComponent,
    BlockSelectionComponent,
    BlockSelectionRequiredValidator,
    CheckboxComponent,
    FcomCheckboxRequiredValidator,
    RadioItemComponent,
    TextInputComponent,
    SelectInputComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule.withConfig({
      callSetDisabledState: 'whenDisabledForLegacyCode',
    }),
    UiTranslateModule,
    IconsModule,
    TooltipModule,
  ],
  exports: [
    AbstractCheckboxComponent,
    AbstractInputComponent,
    AbstractNgModelComponent,
    FloatingInputComponent,
    BlockSelectionGroupComponent,
    BlockSelectionComponent,
    BlockSelectionRequiredValidator,
    CheckboxComponent,
    FcomCheckboxRequiredValidator,
    RadioItemComponent,
    TextInputComponent,
    SelectInputComponent,
  ],
})
export class FcomFormsModule {}
